import { CrosswalkMappingSetType } from './types'

const requiredCrosswalkParams: (keyof Omit<CrosswalkMappingSetType, 'id'>)[] = [
  'name',
  'method',
  'status',
  'source_framework_id',
  'target_framework_id',
]

export function isCompleteCrosswalk(
  data: Partial<Omit<CrosswalkMappingSetType, 'id'>>,
): data is Omit<CrosswalkMappingSetType, 'id'> {
  return requiredCrosswalkParams.every((k) => data[k] !== undefined)
}
